<template>
    <img v-if="foto" :src="foto" :alt="nombre" class="user-avatar" :style="tamanoEstilo" />
    <div v-else class="user-avatar user-avatar--placeholder" :style="tamanoEstilo" :title="nombre">
        {{ iniciales }}
    </div>
</template>

<script setup>
    import { computed } from 'vue';

    // Avatar reutilizable: muestra la foto de perfil del usuario si existe,
    // o un círculo con sus iniciales si todavía no ha subido una (en vez de
    // una foto de stock genérica, que no tiene sentido para un usuario real
    // sin foto propia). Se usa en el encabezado y en la página de perfil.
    const props = defineProps({
        usuario: { type: Object, default: null },
        size: { type: Number, default: 40 },
    });

    const nombre = computed(() => {
        if (!props.usuario) return 'Usuario';
        const completo = `${props.usuario.first_name || ''} ${props.usuario.last_name || ''}`.trim();
        return completo || props.usuario.username || 'Usuario';
    });

    const foto = computed(() => props.usuario?.foto || null);

    const iniciales = computed(() => {
        const u = props.usuario;
        if (!u) return '?';
        const inicial1 = (u.first_name || u.username || '?').charAt(0);
        const inicial2 = (u.last_name || '').charAt(0);
        return (inicial1 + inicial2).toUpperCase() || '?';
    });

    const tamanoEstilo = computed(() => ({
        width: `${props.size}px`,
        height: `${props.size}px`,
        fontSize: `${Math.max(props.size * 0.4, 12)}px`,
    }));
</script>

<style scoped>
    .user-avatar {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-radius: 50% !important;
        object-fit: cover !important;
        flex: none;
    }

    .user-avatar--placeholder {
        background-color: var(--bs-tertiary-bg, #eef1f7);
        color: var(--bs-secondary-color, #506690);
        font-weight: 600;
        letter-spacing: 0.02em;
        border: 1px solid var(--bs-border-color, #e0e6ed);
    }
</style>
